/**
 * Single source of truth for SuperAdmin sidebar (and top-menu) navigation.
 */

/**
 * @param {string} pathname
 * @param {string|string[]|undefined} matchOrPath
 * @param {{ end?: boolean }} [options]
 */
export function isPathActive(pathname, matchOrPath, options = {}) {
  if (!matchOrPath) return false;
  const path = (pathname || "").toLowerCase();
  const { end = false } = options;
  const matches = Array.isArray(matchOrPath) ? matchOrPath : [matchOrPath];

  return matches.filter(Boolean).some((raw) => {
    const target = String(raw).toLowerCase();
    if (end) {
      return path === target || path === `${target}/`;
    }
    if (target === "/" || target === "/dashboard") {
      return path === "/" || path === "/dashboard" || path.startsWith("/dashboard/");
    }
    return path === target || path.startsWith(`${target}/`) || path.startsWith(target);
  });
}

/** Find the top-level menu id whose match hits the current path (for accordion auto-expand). */
export function findActiveSectionId(pathname, menus = Menu) {
  for (const item of menus) {
    if (!item.children?.length) continue;
    if (isPathActive(pathname, item.match || item.path)) {
      return item.id;
    }
  }
  return null;
}

const Menu = [
  {
    id: "dashboard",
    path: "/dashboard",
    icon: "fa fa-chart-line",
    title: "Dashboard",
    match: ["/", "/dashboard"],
  },
  {
    id: "companies",
    path: "/company/manageCompany",
    icon: "fa-solid fa-building",
    title: "Companies",
    match: ["/company"],
  },
  {
    id: "allergens",
    path: "/allergen/manageAllergens",
    icon: "fa-solid fa-exclamation-triangle",
    title: "Allergens",
    match: ["/allergen"],
  },
  {
    id: "quotes",
    path: "/quotes/manageQuotes",
    icon: "fa-solid fa-quote-left",
    title: "Quotes",
    match: ["/quotes"],
  },
  {
    id: "twilio",
    path: "/twilio/platformSettings",
    icon: "fa-solid fa-comment-sms",
    title: "Twilio Platform",
    match: ["/twilio"],
  },
  {
    id: "paymentGatewayPlatforms",
    path: "/paymentGatewayPlatform/managePlatforms",
    icon: "fa-solid fa-credit-card",
    title: "Payment Gateways",
    match: ["/paymentGatewayPlatform"],
  },
  {
    id: "subscriptionDojo",
    path: "/subscriptionDojo/settings",
    icon: "fa-solid fa-file-invoice-dollar",
    title: "Subscription Dojo",
    match: ["/subscriptionDojo"],
  },
  {
    id: "packages",
    path: "/packages/managePackages",
    icon: "fa-solid fa-box",
    title: "Packages",
    match: ["/packages"],
  },
  {
    id: "smsPackages",
    path: "/smsPackages/manage",
    icon: "fa-solid fa-comments",
    title: "SMS Packages",
    match: ["/smsPackages"],
  },
];

export default Menu;
